export default __webpack_public_path__ + "static/end-game-timesup-ea26b03e2d2c9b2035a0700eed7506d7.png";